import { useMemo } from 'react';

import { useGetInstagramImageFeedQuery } from 'generated/rbi-graphql';

interface InstagramImage {
  mediaUrl: string;
  timestamp: string;
}

interface InstagramFeedContent {
  images: InstagramImage[];
  username: string;
}

interface InstagramFeedResult extends InstagramFeedContent {
  isLoading: boolean;
  refetch: VoidFunction;
}

export const useInstagramFeed = (imageLimit: number): InstagramFeedResult => {
  const { data, loading, refetch } = useGetInstagramImageFeedQuery({
    variables: {
      input: imageLimit,
    },
  });

  const instagramFeedContent = useMemo((): InstagramFeedContent => {
    const queryResult = data?.getImageFeed;

    if (!queryResult?.length) {
      return { images: [], username: '' };
    }

    const images: InstagramImage[] = queryResult.map(image => ({
      mediaUrl: image.media_url,
      timestamp: image.timestamp,
    }));
    const firstImage = queryResult?.[0];
    const username = firstImage?.username ?? '';

    return { images, username };
  }, [data]);

  return { ...instagramFeedContent, isLoading: loading, refetch };
};
